import { SingleEvent } from "@/features/events/components/single/SingleEvent.fetcher";
import { PageDoesntExist } from "@/pageDoesntExist";
import EventsPage from "@/pages/Events/EventsPage";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { siteRoutes } from "../siteRoutesList";

export const eventRoutes = [
  {
    element: brand.hasFeature.zones ? EventsPage : PageDoesntExist,
    path: `${siteRoutes["events"]}`,
  },
  {
    element: brand.hasFeature.zones ? SingleEvent : PageDoesntExist,
    path: `${siteRoutes["eventAndSlug"]}:slug`,
  },
];
